"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJExpositionScene = void 0;
const CGJGeneralMenuScene_1 = require("./CGJGeneralMenuScene");
const KHMenuSpec_1 = require("./KH/Menu/KHMenuSpec");
class CGJExpositionScene extends CGJGeneralMenuScene_1.CGJGeneralMenuScene {
    constructor() {
        super("CGJExpositionScene", false);
    }
    onCreate() {
        console.log("what");
        return new KHMenuSpec_1.KHMenuSpec("", [
            this.addText(.5, .1, "How to Play", .1),
            this.addText(.5, .5, "Your village has angered Cyclus, God of Cycles, by not paying\nits yearly apple tribute. In order to restore time to its\nnormal speed, you must provide Cyclus with 50 apples.\n\nUse WASD/Arrow keys, left thumbstick,\nor click with the mouse to move.\n\nDodge all slime and skeletons. Collect apples.", .05),
        ], this.addConditionalBackOption());
    }
}
exports.CGJExpositionScene = CGJExpositionScene;
